import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    sale: 'c-brand-3'
  }
} satisfies RecursivePartial<ProductConfig['pricing']>
